/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyersectionqr2Inputs */

const en_flyersectionqr2 = /** @type {(inputs: Flyersectionqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR code`)
};

const de_flyersectionqr2 = /** @type {(inputs: Flyersectionqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code`)
};

/**
* | output |
* | --- |
* | "QR code" |
*
* @param {Flyersectionqr2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyersectionqr2 = /** @type {((inputs?: Flyersectionqr2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyersectionqr2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyersectionqr2(inputs)
	return de_flyersectionqr2(inputs)
});
export { flyersectionqr2 as "flyerSectionQr" }